export default "__VITE_ASSET__3e330a60__"